import Drag from './drag' // 全局拖拽指令
import ElFormItemBlurValidate from './el-form-item-blur-validate'
import loopScroll from './loop-scroll'
const directives = {
  Drag,
  ElFormItemBlurValidate,
  loopScroll
}

export default {
  install (vue) {
    Object.keys(directives).forEach(name => {
      vue.directive(name, directives[name])
    })
  }
}
